import { render } from "./Digestive.vue?vue&type=template&id=c2e8fad8"
import script from "./Digestive.vue?vue&type=script&lang=js"
export * from "./Digestive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Digestive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2e8fad8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2e8fad8', __exports__)) {
    api.reload('c2e8fad8', __exports__)
  }
  
  module.hot.accept("./Digestive.vue?vue&type=template&id=c2e8fad8", () => {
    api.rerender('c2e8fad8', render)
  })

}


export default __exports__